import { downloadFile, FileType } from 'commons/utils/file'
import { Text } from 'components'
import { t } from 'i18next'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

type FileErrorToastProps = {
  fileName: string
  file: ArrayBuffer
  messageKey?: string
}

export const FileErrorToast: React.FC<FileErrorToastProps> = ({
  fileName,
  file,
  messageKey = 'common.errors.fileHasInconsistencies',
}) => {
  const handleDownload = () => {
    downloadFile({
      file,
      fileName,
      fileType: FileType.Excel,
    })
  }

  return (
    <S.Content onClick={handleDownload}>
      <Text customColor={theme.colors.ion.danger.onsofter} size="xs" weight="sm">
        {t(messageKey)}
      </Text>
      <S.DownloadLink>
        <Text customColor={theme.colors.ion.danger.strong} size="xs" weight="sm">
          {t('buttons.downloadReport')}
        </Text>
      </S.DownloadLink>
    </S.Content>
  )
}
